/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AccountSetupModalContainerUserQueryVariables = {
    id: string;
};
export type AccountSetupModalContainerUserQueryResponse = {
    readonly User_by_pk: {
        readonly id: string;
    } | null;
};
export type AccountSetupModalContainerUserQuery = {
    readonly response: AccountSetupModalContainerUserQueryResponse;
    readonly variables: AccountSetupModalContainerUserQueryVariables;
};



/*
query AccountSetupModalContainerUserQuery(
  $id: String!
) {
  User_by_pk(id: $id) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "User_by_pk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSetupModalContainerUserQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountSetupModalContainerUserQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6a2748399dcf13901562f49167313d59",
    "id": null,
    "metadata": {},
    "name": "AccountSetupModalContainerUserQuery",
    "operationKind": "query",
    "text": "query AccountSetupModalContainerUserQuery(\n  $id: String!\n) {\n  User_by_pk(id: $id) {\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '3ddc500eadbd2d1c4d9aaeb6bbf3f7d2';
export default node;
